export const OBJECT_POLICY_ACTIONS = [
  { key: 'can_view', label: 'View' },
  { key: 'can_create', label: 'Create' },
  { key: 'can_update', label: 'Edit' },
  { key: 'can_delete', label: 'Delete' },
  { key: 'can_view_all', label: 'View All' },
  { key: 'can_update_all', label: 'Edit All' },
];

/** Primary matrix columns shown for every permission row (mockup-style). */
export const PERMISSION_MATRIX_COLUMNS = OBJECT_POLICY_ACTIONS.slice(0, 4);

/** Extended columns for object rows on wider layouts. */
export const PERMISSION_MATRIX_EXTENDED_COLUMNS = OBJECT_POLICY_ACTIONS.slice(4);

export const EMPTY_GRANTS = {
  features: {},
  objects: {},
  resources: {
    accounts: [],
    campaigns: [],
    form_fields: [],
  },
  record_actions: {},
};

export const EMPTY_RESOURCES = {
  accounts: [],
  campaigns: [],
  form_fields: [],
};
